import React from "react";
import underMaintenanceSVG from "../../../assets/under-maintenance.svg";
import { createStyles, Grid, makeStyles, Typography, TypographyProps, useMediaQuery, useTheme } from "@material-ui/core";

export enum MaintenanceType {
  ERROR = "ERROR",
  MAINTENANCE = "MAINTENANCE",
}

export const getUnderMaintenanceProps = (
  maintenanceType?: MaintenanceType
): IUnderMaintenanceProps => {
  let underMaintenanceProps = {
    title: "Oops!",
    firstLine: `We're sorry, but an error has occurred`,
    secondLine:
      "Our team is working to resolve the issue as quickly as possible.",
    thirdLine: "Please try again later.",
  };

  if (maintenanceType === MaintenanceType.ERROR) {
    underMaintenanceProps = {
      title: "We'll be back soon!",
      firstLine: "Our service is currently undergoing scheduled maintenance.",
      secondLine:
        "We expect to be back up and running by [insert time and timezone].",
      thirdLine: "Thank you for your patience.",
    };
  }

  return underMaintenanceProps;
};

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      alignItems: "center",
      display: "flex",
      height: "100vh",
      justifyContent: "space-around",
    },
    wrapperMobile: {
      display: "flex",
      height: "100vh",
      justifyContent: "center",
      padding: "20px",
      textAlign: "center",
    },
    image: {
      height: "100%",
      width: "100%",
    },
    title: {
      fontWeight: "bold",
      paddingBottom: "12px",
    },
  })
);

export interface IUnderMaintenanceProps {
  firstLine: string;
  secondLine: string;
  thirdLine: string;
  title: string;
}
interface ITypographyPlusProps extends TypographyProps {
  text: string;
}

const UnderMaintenance = ({
  firstLine,
  secondLine,
  thirdLine,
  title,
}: IUnderMaintenanceProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const renderTypographyWithSpacing = ({
    variant = "body1",
    text,
  }: Partial<ITypographyPlusProps>) => {
    return (
      <Typography variant={variant}>
        {text}
      </Typography>
    );
  };

  const renderDesktop = () => {
    return (
      <>
        <Grid item xs={6}>
          <img alt="logo" src={underMaintenanceSVG} className={classes.image} />
        </Grid>
        <Grid item xs={6}>
          <div>
            <Typography className={classes.title} variant="h2">
              {title}
            </Typography>
            {renderTypographyWithSpacing({ text: firstLine })}
            {renderTypographyWithSpacing({ text: secondLine })}
            {renderTypographyWithSpacing({
              variant: "caption",
              text: thirdLine,
            })}
          </div>
        </Grid>
      </>
    );
  };
  const renderMobile = () => {
    return (
      <>
        <Grid item xs={12}>
          <img alt="logo" src={underMaintenanceSVG} className={classes.image} />
        </Grid>
        <Grid item xs={12}>
          <div>
            <Typography variant="h4">{title}</Typography>
            {renderTypographyWithSpacing({ text: firstLine })}
            {renderTypographyWithSpacing({ text: secondLine })}
            {renderTypographyWithSpacing({
              variant: "caption",
              text: thirdLine,
            })}
          </div>
        </Grid>
      </>
    );
  };

  return (
    <Grid
      container
      className={isMdUp ? classes.wrapper : classes.wrapperMobile}
    >
      {isMdUp ? renderDesktop() : renderMobile()}
    </Grid>
  );
};

export default UnderMaintenance;
